import React from 'react';
// Dynamic imports keep reports and other pages out of inventory startup.
const loaders = {
  ModernGlassDashboard: () => import("../pages/Dashboard"),
  PurchaseRequisitionUI: () => import("../PurchaseRequest/CreatePurchaseRequisitionUI"),
  ReferenceCards: () => import("../Maintenance/ReferenceCards"),
  DepartmentPage: () => import("../Maintenance/Departments"),
  CompanyPage: () => import("../Maintenance/Companies"),
  LocationPage: () => import("../Maintenance/Locations"),
  VendorPage: () => import("../Maintenance/Vendors"),
  ShippingInformation: () => import("../Maintenance/ShippingInformation"),
  ExpenseTypePage: () => import("../Maintenance/ExpenseType"),
  UserLevelPage: () => import("../Maintenance/UserLevel"),
  UserManagement: () => import("../Maintenance/Users"),
  PaymentMethodsPage: () => import("../Maintenance/PaymentMethod"),
  MyRequestsPage: () => import("../PurchaseRequest/MyRequestsPage"),
  PurchaseOrder: () => import("../PurchaseOrder/PurchaseOrder"),
  PurchaseOrdersPage: () => import("../PurchaseOrder/PurchaseOrdersPage"),
  POReceiving: () => import("../PurchaseOrder/POReceiving"),
  POInvoiceTransmittal: () => import("../PurchaseOrder/POInvoiceTransmittal"),
  PRApproval: () => import("../Approvals/PRApproval"),
  POApproval: () => import("../Approvals/POApproval"),
  PRApprovalHistory: () => import("../ApprovalHistory/PRApprovalHistory"),
  POApprovalHistory: () => import("../ApprovalHistory/POApprovalHistory"),
  PO_Reports: () => import("../Reports/PO_Reports"),
  PR_Reports: () => import("../Reports/PR_Reports"),
  PositionLevelAccess: () => import("../Access_sidebar/PositionLevelAccess"),
  MyProfile: () => import("../Account/Myprofile"),
  Settingss: () => import("../Setting/Settings"),
  LicenseSelectionPage: () => import("../Maintenance/License"),
  ApproverPositionManagement: () => import("../Maintenance/ApproverPositionManagement"),
  ChangePasswordPage: () => import("../Setting/Changepassword"),
  Website_status_maintenance: () => import("../Maintenance/Website_status_maintenance"),
  InventoryDestinationManager: () => import("../Inventory/InventoryDestinationManager"),
  InventoryDistribution: () => import("../Inventory/InventoryDistribution"),
  WebsiteInfoPage: () => import("../Maintenance/WebsiteInfoPage"),
  ItemMaintenance: () => import("../Maintenance/Item"),
  ItemUomConversion: () => import("../Maintenance/ItemUomConversion"),
  BatchMaintenance: () => import("../Maintenance/BatchMaintenance"),
  SecondPR_Approval: () => import("../2ndApproval/PR_Approval"),
  GoodsReceipt: () => import("../GR/GoodsReceipt"),
  WarehousePage: () => import("../Maintenance/Warehouse"),
  GRViewList: () => import("../GR/GRViewList"),
  BatchNumberPage: () => import("../GR/BatchNumberPage"),
  InventoryList: () => import("../InventoryStock/InventoryList"),
  StockAdjustmentList: () => import("../InventoryStock/StockAdjustmentList"),
  StockAdjustmentForm: () => import("../InventoryStock/Stockadjustmentform"),
  MaterialRequestForm: () => import("../Materialrequestform/Materialrequestform"),
  ItemRequestFormPending: () => import("../Materialrequestform/ItemRequestFormPending"),
  GoodIssue: () => import("../Materialrequestform/GoodIssue"),
  MaterialRequestApproval: () => import("../Approvals/Materialrequestapproval"),
  PrPoTagsItem: () => import("../PurchaseRequest/PrPoTagsItem"),
  LicenseManagement: () => import("../Maintenance/LicenseManagement"),
  RmReports: () => import("../Reports/RMReports"),
  FuelRequisitionList: () => import("../FuelRequisitionForm/FuelRequisitionList"),
  FuelRequisitionForm: () => import("../FuelRequisitionForm/FuelRequisitionForm"),
  ReturnRequestList: () => import("../Materialrequestform/Returnrequestlist"),
  FuelRequisitionApproval: () => import("../FuelRequisitionForm/FuelRequisitionApproval"),
  ShipToShipRequestViewer: () => import("../Materialrequestform/Shiptoshiprequestviewer"),
  MRFolderByDate: () => import("../Materialrequestform/MRFolderByDate"),
  Logs: () => import("../pages/Logs"),
  NotificationConfig: () => import("../Notification/Notificationconfig"),
  PRPOManual: () => import("../pages/PRPOManual"),
  NotificationSettings: () => import("../Notification/NotificationSettings"),
  QuotationView: () => import("../Quotations/QuotationView"),
  TruckPage: () => import("../Maintenance/Truck"),
  Gatepass: () => import("../Materialrequestform/Gatepass"),
  FuelHistory: () => import("../FuelRequisitionForm/FuelHistory"),
  ReceivingReports: () => import("../GR/ReceivingReports"),
  Requestor: () => import("../Maintenance/Requestor"),
  QuotationApp: () => import("../Quotations/QuotationApp"),
  CollectionReceipt: () => import("../Scrap/CollectionReceipt"),
  ScrapCodesPage: () => import("../Maintenance/ScrapCodesPage"),
  ScrapLoadingForm: () => import("../Scrap/Scraploadingform"),
  ProductionScrap: () => import("../Scrap/ProductionCrap"),
  SalesOrder: () => import("../Scrap/SalesOrder"),
  DisposalApproval: () => import("../Scrap/DisposalApproval"),
  Disposal_Form: () => import("../Scrap/Disposal_Form"),
  CombinedDashboard: () => import("../pages/Combineddashboard"),
  MotorpoolScrap: () => import("../Scrap/MotorpoolScrap"),
  LPNGenerate: () => import("../LPN/Lpngenerate"),
  ReferenceCardAccess: () => import("../Access_sidebar/Referencecardaccess"),
  Rackings_Inventory: () => import("../InventoryStock/Rackings_Inventory"),
  ItemRequestApprovalReleasedBy: () => import("../Approvals/ItemRequestApprovalReleasedBy"),
  Marketing_Itemsmaintenance: () => import("../Maintenance/Marketing_Itemsmaintenance"),
  CustomerMaintenance: () => import("../Maintenance/CustomerMaintenance"),
  Inventory_Marketing_PAGE: () => import("../Marketing_SO/Inventory_Marketing_PAGEs"),
  SO_Marketing_FORM: () => import("../Marketing_SO/SO_Marketing_FORM"),
  GR_Marketing_LIST: () => import("../Marketing_SO/GR_Marketing_LIST"),
  GR_Marketing_FORM: () => import("../Marketing_SO/GR_Marketing_FORM"),
  GR_Marketing_Posted_History: () => import("../Marketing_SO/GR_Marketing_Posted_History"),
  FG_Withdrawal_FORM_LIST: () => import("../Marketing_SO/FG_Withdrawal_FORM_LIST"),
  FG_Withdrawal_FORM: () => import("../Marketing_SO/FG_Withdrawal_FORM"),
  SO_Marketing_LIST: () => import("../Marketing_SO/SO_Marketing_LIST"),
  AccountingSystemSettings: () => import("../Maintenance/AccountingSystemSettings"),
  ItemDirect: () => import("../InventoryStock/Itemdirect"),
  Fuel_diesel: () => import("../FuelRequisitionForm/Fuel_diesel"),
  FuelMonitor: () => import("../FuelRequisitionForm/Fuelmonitor"),
  GasmanList: () => import("../Maintenance/Gasmanlist"),
  ModuleHub: () => import("../Materialrequestform/Modulehub"),
  RrImportChina: () => import("../CreateFroms/Rrimportchina"),
  RrLocal: () => import("../CreateFroms/Rrlocal"),
  Trucktoolsform: () => import("../CreateFroms/Trucktoolsform"),
  BorrowingForm: () => import("../CreateFroms/Borrowingform"),
  SalaryDeductionForm: () => import("../CreateFroms/Salarydeductionform"),
};
const pageNames = {
  "dashboard": "ModernGlassDashboard",
  "CreatePO": "PurchaseRequisitionUI",
  "referencess": "ReferenceCards",
  "department": "DepartmentPage",
  "companyPage": "CompanyPage",
  "locationPage": "LocationPage",
  "vendorPage": "VendorPage",
  "shippingInformation": "ShippingInformation",
  "expenseTypePage": "ExpenseTypePage",
  "userLevelPage": "UserLevelPage",
  "UserManagement": "UserManagement",
  "PaymentMethodsPage": "PaymentMethodsPage",
  "PurchaseRequests": "MyRequestsPage",
  "PurchaseOrder": "PurchaseOrder",
  "PurchaseOrdersPage": "PurchaseOrdersPage",
  "POReceiving": "POReceiving",
  "POInvoiceTransmittal": "POInvoiceTransmittal",
  "PRApproval": "PRApproval",
  "POApproval": "POApproval",
  "PRApprovalHistory": "PRApprovalHistory",
  "POApprovalHistory": "POApprovalHistory",
  "PO_Reports": "PO_Reports",
  "PR_Reports": "PR_Reports",
  "PositionLevelAccess": "PositionLevelAccess",
  "MyProfile": "MyProfile",
  "Settingss": "Settingss",
  "LicenseSelectionPage": "LicenseSelectionPage",
  "ApproverPositionManagement": "ApproverPositionManagement",
  "ChangePassword": "ChangePasswordPage",
  "Website": "Website_status_maintenance",
  "InventoryDestinationManager": "InventoryDestinationManager",
  "InventoryDistribution": "InventoryDistribution",
  "WebsiteInformation": "WebsiteInfoPage",
  "ItemMaintenance": "ItemMaintenance",
  "ItemUomConversion": "ItemUomConversion",
  "BatchMaintenance": "BatchMaintenance",
  "SecondPR_Approval": "SecondPR_Approval",
  "GoodsReceipt": "GoodsReceipt",
  "Requestor": "Requestor",
  "WarehousePage": "WarehousePage",
  "GRViewList": "GRViewList",
  "BatchNumber": "BatchNumberPage",
  "InventoryList": "InventoryList",
  "StockAdjustmentList": "StockAdjustmentList",
  "StockAdjustmentForm": "StockAdjustmentForm",
  "ItemRequestForm": "MaterialRequestForm",
  "ItemRequestFormPending": "ItemRequestFormPending",
  "ReturnRequestList": "ReturnRequestList",
  "ItemRequestApproval": "MaterialRequestApproval",
  "LicenseManagement": "LicenseManagement",
  "IRReports": "RmReports",
  "FuelRequestForm": "FuelRequisitionForm",
  "FuelRequisitionList": "FuelRequisitionList",
  "FuelRequisitionApproval": "FuelRequisitionApproval",
  "ShipToShipRequestViewer": "ShipToShipRequestViewer",
  "MRFolderByDate": "MRFolderByDate",
  "Notification": "NotificationConfig",
  "PRPOManual": "PRPOManual",
  "NotificationSettings": "NotificationSettings",
  "CombinedDashboard": "CombinedDashboard",
  "Quotation": "QuotationApp",
  "QuotationView": "QuotationView",
  "Gatepass": "Gatepass",
  "Truck": "TruckPage",
  "FuelHistory": "FuelHistory",
  "ReceivingReports": "ReceivingReports",
  "Disposal_Form": "Disposal_Form",
  "DisposalApproval": "DisposalApproval",
  "Motorpool_Scrap": "MotorpoolScrap",
  "Scrap_Loding_Form": "ScrapLoadingForm",
  "ScrapCodesPage": "ScrapCodesPage",
  "LPNGenerate": "LPNGenerate",
  "GoodIssue": "GoodIssue",
  "AccountingSystemSettings": "AccountingSystemSettings",
  "GasmanList": "GasmanList",
  "ReferenceCardAccess": "ReferenceCardAccess",
  "FG_Withdrawal_FORM": "FG_Withdrawal_FORM",
  "FG_Withdrawal_FORM_LIST": "FG_Withdrawal_FORM_LIST",
  "GR_Marketing_FORM": "GR_Marketing_FORM",
  "GR_Marketing_LIST": "GR_Marketing_LIST",
  "GR_Marketing_Posted_History": "GR_Marketing_Posted_History",
  "SO_Marketing_FORM": "SO_Marketing_FORM",
  "Inventory_Marketing_PAGE": "Inventory_Marketing_PAGE",
  "CustomerMaintenance": "CustomerMaintenance",
  "SO_Marketing_LIST": "SO_Marketing_LIST",
  "Marketing_Itemsmaintenance": "Marketing_Itemsmaintenance",
  "FuelMonitor": "FuelMonitor",
  "ItemRequestApprovalReleasedBy": "ItemRequestApprovalReleasedBy",
  "Fuel_diesel": "Fuel_diesel",
  "Rackings_Inventory": "Rackings_Inventory",
  "ItemDirect": "ItemDirect",
  "Collection_Receipt": "CollectionReceipt",
  "Sales_Order_Scrap": "SalesOrder",
  "RrImportChina": "RrImportChina",
  "RrLocal": "RrLocal",
  "Trucktoolsform": "Trucktoolsform",
  "BorrowingForm": "BorrowingForm",
  "SalaryDeductionForm": "SalaryDeductionForm",
  "ModuleHub": "ModuleHub",
  "Production_Scrap": "ProductionScrap",
  "Logs": "Logs"
};
const loaded = new Map();
const pending = new Map();
export function preloadPage(pageId) {
  const name = pageNames[pageId] || 'ModernGlassDashboard';
  if (loaded.has(name)) return Promise.resolve();
  if (!pending.has(name)) {
    const request = loaders[name]().then(module => { loaded.set(name, module.default); });
    pending.set(name, request);
    request.catch(() => { if (pending.get(name) === request) pending.delete(name); });
  }
  return pending.get(name);
}
export const pageComponents = Object.fromEntries(Object.keys(loaders).map(name => [name, function Page(props) {
  const Component = loaded.get(name);
  return <Component {...props} />;
}]));
